/*
 * Ecrou | Özel ürün detay sayfası etkileşimleri
 * Bağımlılık yok (jQuery gerekmez). Shopify tema düzenleyicisiyle uyumludur.
 */
(function () {
  'use strict';

  if (window.EcrouPDP) return;
  window.EcrouPDP = { version: '1.0.0' };

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------------------------------ */
  /* Yardımcılar                                                         */
  /* ------------------------------------------------------------------ */
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function all(scope, selector) {
    return toArray((scope || document).querySelectorAll(selector));
  }

  function scrollBehavior() {
    return reduceMotion ? 'auto' : 'smooth';
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function isConnected(node) {
    return document.documentElement.contains(node);
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function formatMoney(cents, format) {
    var fmt = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';
    var rules = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.']
    };
    var rule = rules[kind] || rules.amount;
    var parts = (Math.round(Number(cents) || 0) / 100).toFixed(rule[0]).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, rule[1]);
    var value = parts[1] ? whole + rule[2] + parts[1] : whole;
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /*
   * Bitiş tarihi okuma. Desteklenen biçimler:
   * 2026-10-31 23:59  |  2026-10-31  |  31.10.2026 23:59  |  31.10.2026
   * Saat yazılmazsa günün sonu (23:59:59) kabul edilir. Saat, mağaza saat dilimine göredir.
   */
  function parseEnd(value, offsetHours) {
    if (!value) return null;
    var s = String(value).trim();
    var iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
    var tr = s.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);
    var y, mo, d, h, mi, se;
    if (iso) {
      y = +iso[1]; mo = +iso[2]; d = +iso[3]; h = iso[4]; mi = iso[5]; se = iso[6];
    } else if (tr) {
      y = +tr[3]; mo = +tr[2]; d = +tr[1]; h = tr[4]; mi = tr[5];
    } else {
      var parsed = Date.parse(s);
      return isNaN(parsed) ? null : parsed;
    }
    var hasTime = h !== undefined;
    var utc = Date.UTC(y, mo - 1, d, hasTime ? +h : 23, hasTime ? +mi : 59, hasTime ? +(se || 0) : 59);
    return utc - (Number(offsetHours) || 0) * 3600000;
  }

  /* Satın alma alanına kaydırır (buton görünümün altına gelecek şekilde). */
  function scrollToBuy() {
    var anchor = document.querySelector('[data-ecr-buy-anchor]');
    if (!anchor) return false;
    var rect = anchor.getBoundingClientRect();
    var top = window.pageYOffset + rect.bottom - window.innerHeight + 24;
    window.scrollTo({ top: Math.max(0, top), behavior: scrollBehavior() });
    return true;
  }

  /* ------------------------------------------------------------------ */
  /* Yatay slider (yorumlar, kısa yorumlar)                              */
  /* ------------------------------------------------------------------ */
  function initSlider(el) {
    if (el.__ecrReady) return;
    el.__ecrReady = true;

    var track = el.querySelector('[data-ecr-track]');
    if (!track) return;
    var dotsWrap = el.querySelector('[data-ecr-dots]');
    var prevs = all(el, '[data-ecr-prev]');
    var nexts = all(el, '[data-ecr-next]');
    var dots = [];

    function items() {
      return toArray(track.children);
    }

    function step() {
      var list = items();
      return list.length > 1 ? list[1].offsetLeft - list[0].offsetLeft : track.clientWidth;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function pages() {
      var s = step();
      return s > 0 ? Math.round(maxScroll() / s) + 1 : 1;
    }

    function current() {
      if (track.scrollLeft >= maxScroll() - 4) return pages() - 1;
      var s = step();
      return s > 0 ? Math.round(track.scrollLeft / s) : 0;
    }

    function go(index) {
      var target = Math.max(0, Math.min(index, pages() - 1)) * step();
      track.scrollTo({ left: Math.min(target, maxScroll()), behavior: scrollBehavior() });
    }

    function update() {
      var active = current();
      dots.forEach(function (dot, k) {
        dot.setAttribute('aria-current', k === active ? 'true' : 'false');
      });
      prevs.forEach(function (btn) {
        btn.disabled = track.scrollLeft <= 4;
      });
      nexts.forEach(function (btn) {
        btn.disabled = track.scrollLeft >= maxScroll() - 4;
      });
    }

    function build() {
      var count = pages();
      el.classList.toggle('is-static', maxScroll() <= 4);
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        dots = [];
        if (count > 1) {
          for (var i = 0; i < count; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ecr-dot';
            dot.setAttribute('aria-label', (el.getAttribute('data-dot-label') || 'Slayt') + ' ' + (i + 1));
            dot.addEventListener('click', go.bind(null, i));
            dotsWrap.appendChild(dot);
            dots.push(dot);
          }
        }
      }
      update();
    }

    prevs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(current() - 1);
      });
    });
    nexts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(current() + 1);
      });
    });
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(build, 150));
    build();
  }

  /* ------------------------------------------------------------------ */
  /* Video kartları                                                      */
  /* ------------------------------------------------------------------ */
  function initVideo(wrap) {
    if (wrap.__ecrReady) return;
    wrap.__ecrReady = true;

    var video = wrap.querySelector('video');
    var toggle = wrap.querySelector('[data-ecr-video-toggle]');
    if (!video) return;
    var isAutoplay = wrap.hasAttribute('data-autoplay');

    function sync() {
      wrap.classList.toggle('is-playing', !video.paused);
    }

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    if (isAutoplay && reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    sync();

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) {
          if (!isAutoplay) {
            all(document, '[data-ecr-video]:not([data-autoplay]) video').forEach(function (other) {
              if (other !== video) other.pause();
            });
          }
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        } else {
          video.pause();
        }
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Geri sayım: yalnızca girilen gerçek bitiş tarihine kadar çalışır.   */
  /* Süre dolunca gizlenir, kendiliğinden yeniden başlamaz.              */
  /* ------------------------------------------------------------------ */
  function initCountdown(el) {
    if (el.__ecrReady) return;
    el.__ecrReady = true;

    var wrap = el.closest('[data-ecr-countdown-wrap]') || el;
    var end = parseEnd(el.getAttribute('data-end'), parseFloat(el.getAttribute('data-utc-offset') || '3'));
    if (end === null || end <= Date.now()) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;

    var dEl = el.querySelector('[data-d]');
    var hEl = el.querySelector('[data-h]');
    var mEl = el.querySelector('[data-m]');
    var sEl = el.querySelector('[data-s]');
    var dUnit = dEl ? dEl.closest('[data-unit]') : null;
    var dSep = el.querySelector('[data-sep-d]');
    var timer;

    function tick() {
      if (!isConnected(el)) {
        clearInterval(timer);
        return;
      }
      var diff = end - Date.now();
      if (diff <= 0) {
        wrap.hidden = true;
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      if (dEl) {
        dEl.textContent = pad(days);
        if (dUnit) dUnit.hidden = days === 0;
        if (dSep) dSep.hidden = days === 0;
      } else {
        hours += days * 24;
      }
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (sEl) sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------ */
  /* Tahmini teslimat                                                    */
  /* ------------------------------------------------------------------ */
  function initDelivery(el) {
    if (el.__ecrReady) return;
    el.__ecrReady = true;

    var offset = parseFloat(el.getAttribute('data-utc-offset') || '3');
    var skipWeekend = el.getAttribute('data-skip-weekend') === 'true';
    var processing = parseInt(el.getAttribute('data-processing') || '0', 10);
    var minDays = parseInt(el.getAttribute('data-min') || '1', 10);
    var maxDays = Math.max(minDays, parseInt(el.getAttribute('data-max') || String(minDays), 10));
    var useCutoff = el.getAttribute('data-use-cutoff') === 'true';
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '15', 10);
    var dateEl = el.querySelector('[data-ecr-delivery-date]');
    var cutWrap = el.querySelector('[data-ecr-cutoff-wrap]');
    var cutTime = el.querySelector('[data-ecr-cutoff-time]');
    var locale = document.documentElement.lang || 'tr';
    var formatter;
    try {
      formatter = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
    } catch (e) {
      formatter = new Intl.DateTimeFormat('tr', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
    }
    var timer;

    function isBusinessDay(date) {
      var day = date.getUTCDay();
      return !skipWeekend || (day !== 0 && day !== 6);
    }

    function addBusinessDays(date, count) {
      var result = new Date(date.getTime());
      var added = 0;
      while (added < count) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (isBusinessDay(result)) added++;
      }
      return result;
    }

    function render() {
      if (!isConnected(el)) {
        clearInterval(timer);
        return;
      }
      /* Mağaza saatine kaydırılmış "şimdi": UTC alanları mağaza yerel saatini gösterir. */
      var now = new Date(Date.now() + offset * 3600000);
      var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      var beforeCutoff = useCutoff && isBusinessDay(today) && now.getUTCHours() < cutoff;
      var shipDate;
      if (useCutoff) {
        shipDate = beforeCutoff ? today : addBusinessDays(today, 1);
      } else {
        shipDate = processing > 0 ? addBusinessDays(today, processing) : today;
      }
      var from = addBusinessDays(shipDate, minDays);
      var to = addBusinessDays(shipDate, maxDays);

      if (dateEl) {
        dateEl.textContent = from.getTime() === to.getTime()
          ? formatter.format(from)
          : formatter.format(from) + ' – ' + formatter.format(to);
      }

      if (cutWrap) {
        if (beforeCutoff) {
          var left = today.getTime() + cutoff * 3600000 - now.getTime();
          var hours = Math.floor(left / 3600000);
          var minutes = Math.floor((left % 3600000) / 60000);
          if (cutTime) {
            cutTime.textContent = (hours > 0 ? hours + ' ' + (el.getAttribute('data-hours-label') || 'sa') + ' ' : '') +
              minutes + ' ' + (el.getAttribute('data-minutes-label') || 'dk');
          }
          cutWrap.hidden = false;
        } else {
          cutWrap.hidden = true;
        }
      }
    }

    render();
    timer = setInterval(render, 30000);
  }

  /* ------------------------------------------------------------------ */
  /* Stok durumu (yalnızca gerçek envanter verisiyle)                    */
  /* ------------------------------------------------------------------ */
  function renderStock(el, variant) {
    if (!el) return;
    var texts = {};
    try {
      texts = JSON.parse(el.getAttribute('data-texts') || '{}');
    } catch (e) {
      texts = {};
    }
    var low = parseInt(el.getAttribute('data-low') || '10', 10);
    var full = Math.max(parseInt(el.getAttribute('data-full') || '100', 10), 1);
    var qty = variant ? Number(variant.qty) || 0 : 0;
    var state;

    if (!variant || !variant.available) state = 'soldout';
    else if (!variant.tracked || (variant.policy === 'continue' && qty <= 0)) state = 'untracked';
    else if (qty <= low) state = 'low';
    else state = 'in';

    el.setAttribute('data-state', state);

    function text(key) {
      return String(texts[state + '_' + key] || '').replace(/\[adet\]/g, String(qty));
    }

    var titleEl = el.querySelector('[data-ecr-stock-title]');
    var textEl = el.querySelector('[data-ecr-stock-text]');
    var badgeEl = el.querySelector('[data-ecr-stock-badge]');
    var fillEl = el.querySelector('[data-ecr-stock-fill]');

    if (titleEl) titleEl.textContent = text('title');
    if (textEl) {
      textEl.textContent = text('text');
      textEl.hidden = !textEl.textContent;
    }
    if (badgeEl) {
      badgeEl.textContent = text('badge');
      badgeEl.hidden = !badgeEl.textContent;
    }
    if (fillEl) {
      var pct = state === 'low' || state === 'in' ? Math.min(100, Math.max(6, Math.round((qty * 100) / full))) : 0;
      fillEl.style.width = pct + '%';
    }
  }

  /* ------------------------------------------------------------------ */
  /* Galeri                                                              */
  /* ------------------------------------------------------------------ */
  function initGallery(gallery) {
    if (!gallery) return null;
    var viewport = gallery.querySelector('[data-ecr-gallery-viewport]');
    if (!viewport) return null;

    var slides = toArray(viewport.children);
    var thumbsWrap = gallery.querySelector('[data-ecr-gallery-thumbs]');
    var thumbs = all(gallery, '[data-ecr-thumb]');
    var prev = gallery.querySelector('[data-ecr-gallery-prev]');
    var next = gallery.querySelector('[data-ecr-gallery-next]');
    var index = 0;

    function setActive(i, instant) {
      index = i;
      thumbs.forEach(function (thumb, k) {
        thumb.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (thumbsWrap && thumbs[i]) {
        var thumb = thumbs[i];
        thumbsWrap.scrollTo({
          left: thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2,
          behavior: instant ? 'auto' : scrollBehavior()
        });
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      slides.forEach(function (slide, k) {
        if (k !== i) {
          all(slide, 'video').forEach(function (video) {
            video.pause();
          });
        }
      });
    }

    function goTo(i, instant) {
      if (!slides.length) return;
      var target = Math.max(0, Math.min(slides.length - 1, i));
      viewport.scrollTo({ left: slides[target].offsetLeft, behavior: instant ? 'auto' : scrollBehavior() });
      setActive(target, instant);
    }

    viewport.addEventListener('scroll', debounce(function () {
      var i = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
      if (i !== index) setActive(i);
    }, 80), { passive: true });

    thumbs.forEach(function (thumb, k) {
      thumb.addEventListener('click', function () {
        goTo(k);
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    setActive(0, true);

    return {
      goToMedia: function (mediaId, instant) {
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(mediaId)) {
            goTo(k, instant);
            return;
          }
        }
      }
    };
  }

  /* ------------------------------------------------------------------ */
  /* Ürün bölümü                                                         */
  /* ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.__ecrReady) return;
    section.__ecrReady = true;

    var data = { variants: [] };
    var dataEl = section.querySelector('[data-ecr-product-json]');
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        data = { variants: [] };
      }
    }

    var moneyFormat = section.getAttribute('data-money-format');
    var form = section.querySelector('form[data-ecr-form]');
    var idInput = form ? form.querySelector('[data-ecr-variant-id]') : null;
    var atc = section.querySelector('[data-ecr-atc]');
    var errorEl = section.querySelector('[data-ecr-error]');
    var stockEl = section.querySelector('[data-ecr-stock]');
    var picker = section.querySelector('[data-ecr-variants]');
    var gallery = initGallery(section.querySelector('[data-ecr-gallery]'));

    /* Sabit konumlu öğeleri (yapışkan çubuk, onay mesajı) body'ye taşı. */
    var floating = all(section, '[data-ecr-floating]');
    floating.forEach(function (node) {
      document.body.appendChild(node);
      all(node, '[data-ecr-countdown]').forEach(initCountdown);
    });
    var toast = floating.filter(function (node) { return node.hasAttribute('data-ecr-toast'); })[0];
    var stickyBar = floating.filter(function (node) { return node.hasAttribute('data-ecr-sticky'); })[0];

    function findVariant(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    var current = findVariant(idInput ? idInput.value : null) || data.variants[0] || null;

    /* Fiyat */
    function updatePrice(variant) {
      if (!variant) return;
      var currentEl = section.querySelector('[data-ecr-price-current]');
      var compareEl = section.querySelector('[data-ecr-price-compare]');
      var badgeEl = section.querySelector('[data-ecr-price-badge]');
      var onSale = variant.compare_at_price > variant.price;
      if (currentEl) currentEl.textContent = formatMoney(variant.price, moneyFormat);
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      }
      if (badgeEl) {
        var pct = onSale ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
        badgeEl.hidden = pct <= 0;
        badgeEl.textContent = String(badgeEl.getAttribute('data-template') || '').replace(/\[yuzde\]/g, String(pct));
      }
    }

    /* Buton */
    function updateButton(variant) {
      if (!atc) return;
      var label = !variant
        ? atc.getAttribute('data-label-unavailable')
        : variant.available
          ? atc.getAttribute('data-label-add')
          : atc.getAttribute('data-label-soldout');
      var textEl = atc.querySelector('[data-ecr-atc-text]');
      atc.disabled = !variant || !variant.available;
      if (textEl) textEl.textContent = label || '';
    }

    function applyVariant(variant) {
      current = variant;
      if (idInput && variant) idInput.value = variant.id;
      updatePrice(variant);
      updateButton(variant);
      renderStock(stockEl, variant);
      if (variant && variant.media_id && gallery) gallery.goToMedia(variant.media_id);
      if (variant && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {
          /* URL güncellenemezse sessizce devam et */
        }
      }
      section.dispatchEvent(new CustomEvent('ecrou:variant-change', { bubbles: true, detail: { variant: variant } }));
    }

    /* Varyant seçici */
    if (picker) {
      var selectedOptions = function () {
        return all(picker, '[data-ecr-option-group]').map(function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      };

      var matchVariant = function (options) {
        for (var i = 0; i < data.variants.length; i++) {
          var variant = data.variants[i];
          var same = variant.options.every(function (value, k) {
            return value === options[k];
          });
          if (same) return variant;
        }
        return null;
      };

      var markAvailability = function (options) {
        all(picker, 'input[data-option-index]').forEach(function (input) {
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          var test = options.slice();
          test[idx] = input.value;
          var variant = matchVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !variant || !variant.available);
        });
      };

      picker.addEventListener('change', function () {
        var options = selectedOptions();
        all(picker, '[data-ecr-option-value]').forEach(function (span) {
          span.textContent = options[parseInt(span.getAttribute('data-ecr-option-value'), 10)] || '';
        });
        markAvailability(options);
        applyVariant(matchVariant(options));
      });

      markAvailability(selectedOptions());
    }

    /* Adet butonları */
    all(section, '[data-ecr-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('input');
        if (!input) return;
        var value = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-ecr-qty'), 10);
        input.value = Math.max(1, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Sepete ekleme */
    function setLoading(on) {
      if (!atc) return;
      atc.classList.toggle('is-loading', on);
      atc.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || section.getAttribute('data-error-text') || '';
      errorEl.hidden = false;
    }

    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    function showToast() {
      if (!toast) {
        window.location.href = routesRoot + 'cart';
        return;
      }
      toast.hidden = false;
      clearTimeout(toast.__ecrTimer);
      toast.__ecrTimer = setTimeout(function () {
        toast.hidden = true;
      }, 7000);
    }

    function cartLooksOpen() {
      var html = window.getComputedStyle(document.documentElement).overflow;
      var body = window.getComputedStyle(document.body).overflow;
      return html === 'hidden' || body === 'hidden';
    }

    function afterAdd(mode) {
      if (mode === 'cart') {
        window.location.href = routesRoot + 'cart';
        return;
      }
      if (mode === 'checkout') {
        window.location.href = routesRoot + 'checkout';
        return;
      }
      /* Stiletto'nun resmi olayı: sepet çekmecesini ve sepet sayacını yeniler. */
      var opened = false;
      var onOpen = function () {
        opened = true;
      };
      document.addEventListener('quick-cart:open', onOpen);
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      setTimeout(function () {
        document.removeEventListener('quick-cart:open', onOpen);
        if (!opened && !cartLooksOpen()) showToast();
      }, 1200);
    }

    if (form) {
      var mode = section.getAttribute('data-after-add') || 'drawer';
      if (mode !== 'native') {
        /* document üzerinde dinlenir: uygulamalar (ör. Kaching) gönderimi kendisi işlerse çakışmaz. */
        document.addEventListener('submit', function (event) {
          if (event.target !== form || event.defaultPrevented) return;
          event.preventDefault();
          if (atc && atc.disabled) return;
          setLoading(true);
          hideError();
          fetch(routesRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: new FormData(form)
          })
            .then(function (res) {
              return res.json().then(function (json) {
                return { ok: res.ok, json: json };
              });
            })
            .then(function (result) {
              if (!result.ok || result.json.status) {
                throw new Error(result.json.description || result.json.message || '');
              }
              afterAdd(mode);
            })
            .catch(function (err) {
              showError(err && err.message);
            })
            .then(function () {
              setLoading(false);
            });
        });
      }
    }

    /* Yapışkan satın alma çubuğu */
    var anchor = section.querySelector('[data-ecr-buy-anchor]');
    if (stickyBar && anchor && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) stickyBar.removeAttribute('inert');
        else stickyBar.setAttribute('inert', '');
        document.body.classList.toggle('ecr-has-sticky', show);
      });
      observer.observe(anchor);

      var stickyBtn = stickyBar.querySelector('[data-ecr-sticky-atc]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          /* Ana butona tıklanır; böylece paket/abonelik uygulamalarının seçimi korunur. */
          if (atc && !atc.disabled) atc.click();
          else scrollToBuy();
        });
      }
    }

    /* İlk durum */
    renderStock(stockEl, current);
    if (current && current.media_id && gallery) gallery.goToMedia(current.media_id, true);
  }

  /* ------------------------------------------------------------------ */
  /* CTA butonları (alt bölümlerdeki "Satın almaya geç" vb.)             */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var cta = event.target && event.target.closest ? event.target.closest('[data-ecr-cta]') : null;
    if (!cta) return;
    var action = cta.getAttribute('data-ecr-cta');
    if (action === 'add') {
      var atc = document.querySelector('[data-ecr-atc]');
      if (atc && !atc.disabled) {
        event.preventDefault();
        atc.click();
        return;
      }
    }
    if (scrollToBuy()) {
      event.preventDefault();
      return;
    }
    var fallback = cta.getAttribute('data-fallback');
    if (fallback) window.location.href = fallback;
  });

  /* ------------------------------------------------------------------ */
  /* Başlatma ve tema düzenleyici desteği                                */
  /* ------------------------------------------------------------------ */
  function initAll(scope) {
    var root = scope || document;
    all(root, '[data-ecr-product]').forEach(initProduct);
    all(root, '[data-ecr-slider]').forEach(initSlider);
    all(root, '[data-ecr-video]').forEach(initVideo);
    all(root, '[data-ecr-countdown]').forEach(initCountdown);
    all(root, '[data-ecr-delivery]').forEach(initDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (!id) return;
    all(document, '[data-ecr-floating][data-section="' + id + '"]').forEach(function (node) {
      node.remove();
    });
    document.body.classList.remove('ecr-has-sticky');
  });

  document.addEventListener('shopify:block:select', function (event) {
    var node = event.target;
    if (!node) return;
    if (node.tagName === 'DETAILS') node.open = true;
    var track = node.closest ? node.closest('[data-ecr-track]') : null;
    if (track) track.scrollTo({ left: node.offsetLeft, behavior: scrollBehavior() });
  });
})();
